export const ORIENTATION_GUARD_MESSAGES = {
  title: "Please rotate your device.",
  description: "This application supports portrait mode only.",
} as const
